export default __webpack_public_path__ + "src/images/packages/lush-private-game-lodge/5c6b3201fe8d572d268697d665b71e94-2.jpg";